/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Processing mode for resource processing stages
 */
export type ProcessingMode = (typeof ProcessingMode)[keyof typeof ProcessingMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessingMode = {
  skip_if_exists: 'skip_if_exists',
  rebuild_always: 'rebuild_always',
  rebuild_if_newer_version: 'rebuild_if_newer_version',
} as const;
